module.exports = __webpack_public_path__ + "assets/img/concealtit.b3bcb1e5.png";